interface IconProps {
  name: 'camera' | 'movies' | 'help' | 'home' | 'play' | 'pause' | 'restart' | 'trash' | 'undo' | 'done' | 'back' | 'sparkles' | 'download' | 'share' | 'film' | 'moveBack' | 'moveForward';
}

const symbols: Record<IconProps['name'], string> = {
  camera: '📷',
  movies: '🎞️',
  help: '💡',
  home: '⌂',
  play: '▶',
  pause: 'Ⅱ',
  restart: '↻',
  trash: '⌫',
  undo: '↶',
  done: '✓',
  back: '←',
  sparkles: '✨',
  download: '⬇',
  share: '📤',
  film: '🎬',
  moveBack: '◀',
  moveForward: '▶',
};

export function Icon({ name }: IconProps) {
  return <span aria-hidden="true" className="icon">{symbols[name]}</span>;
}

